/* import videosApi from "../../api/videos" */
import utilsApi from "../../api/utils"

// general state for the eCommerce
const state = {
  videos: [],
  fetched: false,
  error: false,
  dataShape: [],
  extraInfo: {},
}

const getters = {
  videos: state => state.videos,
  videos_fetched: state => state.fetched,
  videosError: state => state.error,
  videos_dataShape: state => state.dataShape,
  videos_extraInfo: state => state.extraInfo,
}
const actions = {
  async DELETE_videos({ commit }, id) {
    let apiResponse = await utilsApi.deleteVideo(id)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("VIDEOS_SETTING", apiResponse)
      return true
    } else {
      commit("VIDEOS_ERROR")
      return false
    }
  },
  async CREATE_videos({ commit }, video) {
    let apiResponse = await utilsApi.createObject("videos", video)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("VIDEOS_SETTING", apiResponse)
    } else {
      commit("VIDEOS_ERROR")
    }
  },
  async SAVE_videos({ commit }, video) {
    let apiResponse = await utilsApi.saveObject("videos", video)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("VIDEOS_SETTING", apiResponse)
      return true
    } else {
      commit("VIDEOS_ERROR")
      return true
    }
  },
  async FETCH_videos({ commit }) {
    let apiResponse = await utilsApi.getObjects("videos")
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("VIDEOS_SETTING", apiResponse)
      return true
    } else {
      commit("VIDEOS_ERROR")
      return false
    }
  },
}
const mutations = {
  VIDEOS_SETTING: (state, { videos, dataShape, extraInfo }) => {
    console.log(state)
    state.videos = videos
    state.dataShape = dataShape
    state.extraInfo = extraInfo
    state.fetched = true
    state.error = false
  },
  VIDEOS_ERROR: state => {
    state.videos = null
    state.fetched = true
    state.error = false

    state.dataShape = []
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
